import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserList: [],
      sortString: "customer",
      sortDirection: "asc",
    };
    this.sortStringName = "customer";
    this.sortDirection = "asc";
  }
  componentDidMount() {}
  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  render() {
    return (
      <div>
        <Table striped>
          <thead>
            <tr>
              <th>
                Name{" "}
                {this.state.sortString == "username" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("username");
                    }}
                  />
                )}
              </th>
              <th>
                User Name{" "}
                {this.state.sortString == "email" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("email");
                    }}
                  />
                )}
              </th>
              <th>
                Customer{" "}
                {this.state.sortString == "customer" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("customer");
                    }}
                  />
                )}
              </th>
              <th>
                User Type{" "}
                {this.state.sortString == "userType" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("userType");
                    }}
                  />
                )}
              </th>
              <th>
                Time Zone{" "}
                {this.state.sortString == "timezonecity" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("timezonecity");
                    }}
                  />
                )}
              </th>
              <th>
                Last Login{" "}
                {this.state.sortString == "lastLogin" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("lastLogin");
                    }}
                  />
                )}
              </th>
              <th>
                Last IP{" "}
                {this.state.sortString == "lastIp" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("lastIp");
                    }}
                  />
                )}
              </th>
              <th>
                Status{" "}
                {this.state.sortString == "status" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("status");
                    }}
                  />
                )}
              </th>
              <th>
                Updated{" "}
                {this.state.sortString == "updated" ? (
                  <i
                    onClick={this.handleSortDirection}
                    className={`fa ${
                      this.state.sortDirection == "asc"
                        ? "fa-sort-amount-asc"
                        : "fa-sort-amount-desc"
                    }`}
                  />
                ) : (
                  <i
                    className="fa fa-exchange"
                    onClick={() => {
                      this.handleSortString("updated");
                    }}
                  />
                )}
              </th>
              <th style={{ width: "200px" }}></th>
            </tr>
          </thead>
          <tbody>
            {this.props.UserList.map((users, index) => {
              return (
                <tr>
                  <td>{users.userName}</td>
                  <td>{users.email}</td>
                  <a
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: users.customerId,
                          customerName: users.customerName,
                        })
                      )
                    }
                    href={`/users?customerId=${users.customerId}&customerName=${users.customerName}`}
                  >
                    <td>{users.customerName}</td>
                  </a>
                  <td>{users.userType}</td>
                  <td>{users.timeZoneCity}</td>
                  <td>{users.lastLogin ? users.lastLogin.slice(0, -4) : ""}</td>
                  <td>{users.clientIp}</td>
                  <td>{users.status}</td>
                  <td>{users.dbUpdated ? utcToLocal(users.dbUpdated) : ""}</td>
                  <td>
                    <Link to={`/editUser/${users.id}`}>Edit</Link> |{" "}
                    <Link to={`/userDetails/${users.id}`}>Details</Link> |{" "}
                    <Link to={`/deleteUser/${users.id}`}>Delete</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default UserTable;
